// Country articles in the RISC-V wiki. Kept in a light module so pages like
// the Awesome RISC-V list can link the articles without pulling the full
// lesson structures from lessons.js. The full lesson with the same id lives
// in lessons.js; keep both lists in sync when adding a country.
export const COUNTRY_ARTICLES = [
  { id: "brazil", icon: "Flag", subtitle: true },
  { id: "ukraine", icon: "Flag", subtitle: true },
];
